var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconThread = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.2 1c.993 0 1.8.807 1.8 1.8v10.8c0 .993-.807 1.8-1.8 1.8H4.6L1 18.998l.009-16.2c0-.992.808-1.798 1.8-1.798zM17 3H3.009l-.005 11.523L4.026 13.5H17zm-7 6a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2zm4-3.5a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2z"
})));
export default SvgIconThread;